const CompanyType = {
    All : -1,
    InstallationCompany : 0,
    Distributor : 1
};

export default CompanyType;
